<script lang="ts">
    
    import 'swiper/css/pagination';
    import type { MilestoneDto } from "../../global";
    import ActiviyModal from "../Shared/ActiviyModal.svelte";
    import { Swiper, SwiperSlide } from 'swiper/svelte';
    import { getPicturesByLabels } from "../../Services/pictures";
    import { Pagination } from "swiper";
    import PictureMeta from './PictureMeta.svelte';

    export let milestone: MilestoneDto;

    $: pictures = getPicturesByLabels([milestone.id]);

</script>

<ActiviyModal on:close title={milestone.name}>
    <div class="milestone-lightbox">
        {#await pictures}
            Cargando...
        {:then pictures}
            <Swiper modules={[Pagination]} pagination>
                {#each pictures as picture}
                    <SwiperSlide>
                        <div class="picture-slide">
                            <img src={picture.url.medium} alt="">
                            <div class="picture-meta">
                                <PictureMeta {picture} />
                            </div>
                        </div>
                    </SwiperSlide>
                {/each}
            </Swiper>
        {/await}
    </div>
</ActiviyModal>

<style lang="scss">

    .milestone-lightbox {
        height: 100%;
        background-color: #222;

        :global(.swiper) {
            display: flex;
            flex-direction: column;
            height: 100%;
        }

        :global(.swiper-pagination) {
            position: static;
            order: 2;
            height: 50px;
            background-color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
        :global(.swiper-wrapper) {
            order: 1;
            height: auto;
            min-height: 0;
            flex: 1 1 0;
        }

        :global(.swiper-pagination-bullet) {
            background-color: #fff;
            border: 1px solid #222;
        }
        
        :global(.swiper-pagination-bullet-active) {
            background-color: #222;
        }
    }

    .picture-slide {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;

        img {
            display: block;
            flex: 1 1 0;
            min-height: 0;
            object-fit: contain;
        }

        .picture-meta {
            background-color: #fff;
        }
    }

</style>
